/*
 *  (c) 2015 - 2024 ENISCO by FORCAM GmbH
 */

import {TextField} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import React, {ChangeEvent} from 'react'
import {useTimeZone, useUserName} from '@enisco/mcc-react-lib'
import {FormattedMessage} from 'react-intl'
import {getAllTimezones, Timezone} from 'countries-and-timezones'
import useProfile from '../../../../hooks/useProfile'

const Timezones: React.FC = () => {
  const timeZones: {[key: string]: Timezone} = getAllTimezones()
  const [timeZone, setTimeZone] = useTimeZone()
  const [, setProfile] = useProfile()
  const userName = useUserName()

  function getTimeZones() {
    return Object.values(timeZones)
      .filter((value) => value.name.includes('/') || value.name === 'UTC')
      .filter((value) => !value.name.startsWith('Etc'))
      .sort((a, b) => -b.name.localeCompare(a.name))
      .map((value) => value.name)
  }

  const onChange = (event: ChangeEvent<any>, newValue: string) => {
    setTimeZone(newValue)
    if (userName) setProfile({timeZone: newValue})
  }
  return (
    <Autocomplete
      sx={{width: '284px', marginTop: 2}}
      value={timeZone}
      onChange={onChange}
      id='select-timezone'
      disableClearable
      data-testid='timezone-select'
      options={getTimeZones()}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <FormattedMessage
              id='MyProfileDialog.Timezone'
              defaultMessage='Timezone'
            />
          }
        />
      )}
    />
  )
}

export default Timezones
